// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sida-accordion .item .content[data-v-fe0f5e32] {\n  background: #f3f3f3;\n}\n.container .no-data-found[data-v-fe0f5e32] {\n  padding: 100px 16px;\n}\n", ""]);
// Exports
module.exports = exports;
